export default "__VITE_ASSET__BDAigQZi__"